import { Link } from 'react-router-dom'
import AccountIcon from '../../components/AccountIcon'
import { accountPath } from '../../Helpers'

interface Props {
    bankTransaction: BankTransaction
    accounts: Account[]
    // Compte du relevé affiché
    accountId: number
    onRemove: (link: StatementLink) => void
}

interface Placement {
    account: Account
    filename: Filename
    origin: boolean
}

// Pastilles des autres relevés où apparaît l'opération (affichage A de liens-operations.html). Au
// survol : le relevé, un lien pour l'ouvrir, et le retrait du lien.
const LinkedStatements = ({ bankTransaction, accounts, accountId, onRemove }: Props) => {
    const accountById = (id: number) => accounts.find((account) => account.id === id)
    const placements = [
        { account_id: bankTransaction.account_id, filename: bankTransaction.filename, origin: true },
        ...bankTransaction.statement_links.map((link) => ({ account_id: link.account_id, filename: link.filename, origin: false }))
    ]
        .filter((placement) => placement.account_id !== accountId)
        .flatMap((placement) => {
            const account = accountById(placement.account_id)
            return account ? [{ account, filename: placement.filename, origin: placement.origin } as Placement] : []
        })
    // Depuis un relevé lié, retirer l'opération de ce relevé ; depuis l'origine, la retirer de l'autre.
    const currentLink = bankTransaction.statement_links.find((link) => link.account_id === accountId)

    return <>
        { placements.map((placement) => {
            const link = placement.origin ? currentLink : bankTransaction.statement_links.find((link) => link.account_id === placement.account.id)
            const removedFrom = placement.origin ? 'ce relevé' : placement.account.name
            return <span key={placement.account.id} className="linked-statement" tabIndex={0}>
                <AccountIcon account={placement.account} size={16}/>
                <span className="name">{ placement.account.name }</span>
                <span className="linked-statement-popover tl-card">
                    <small>Aussi dans</small>
                    <span className="other">
                        <AccountIcon account={placement.account} size={28}/>
                        <span>
                            <b>{ placement.account.name }</b>
                            <span>{ placement.filename }{ placement.origin && ' · opération d\'origine' }</span>
                        </span>
                    </span>
                    <span className="effect">
                        Même opération : budget, % et libellé perso sont partagés. Comptée <b>une seule fois</b> dans les budgets.
                    </span>
                    <span className="actions">
                        <Link to={accountPath(placement.account, placement.filename)}>Ouvrir dans { placement.account.name } →</Link>
                        { link && <button onClick={() => onRemove(link)}>
                            <i className="fa-solid fa-link-slash"/> Retirer de { removedFrom }
                        </button> }
                    </span>
                </span>
            </span>
        }) }
    </>
}

export default LinkedStatements
